import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var address = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var checkbox = {
  name: "k008qs",
  styles: "display:flex;"
};
export var label = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var labelHeading = /*#__PURE__*/css(designTokenFonts.bodyBold, " margin-top:-1px;");
export var description = /*#__PURE__*/css(designTokenFonts.mini, " color:", colors.neutral.medium.default, ";");